import React from 'react';
import {VARIANT} from '../../../constants';
import cn from 'classnames';


const Button = ({children, type, onClick, className, variant, disabled}) => {
  let variantClass = '';
  if (variant === VARIANT.PRIMARY) {
    variantClass += 'btn-bg-primary hover:bg-[#197D55] text-black hover:text-white';
  } else if (variant === VARIANT.SECONDARY) {
    variantClass += 'bg-[#D9D9D9] border border-transparent hover:border-[#F8C518] hover:border';
  } else if (variant === VARIANT.OUTLINE) {
    variantClass += 'border-primary text-primary';
  } else if (disabled) {
    variantClass += 'bg-[#D9D9D9] text-[#828282]';
  }

  const handleClick = (e) => {
    e && e.preventDefault();
    onClick && onClick(e);
  }
  return (
    <button
      type={type || 'button'}
      disabled={disabled}
      className={cn('relative px-3 rounded-full flex justify-center items-center py-2.5 transition-all duration-300 ease-in-out', variantClass, className)}
      onClick={handleClick}
    >
      {children}
    </button>
  )
}

export default Button